<template>
    <div>
        <div v-if="isEditMode" class="info-wrapper">
            <GdprUpdateContainer
                @savedSuccess="isEditMode=false"
                @cancel="onCancel"
            />
        </div>
        <div v-else class="info-wrapper">
            <div class="info-wrapper__status-box">
                <i
                    class="icon"
                    :class="user.acceptsGeneralPrivacy ? 'icon-check_circle_filled' : 'icon-close_circle_filled'"
                />
                <PrivacyConsentGeneralInfo/>
            </div>
            <div class="info-wrapper__status-box">
                <i
                    class="icon"
                    :class="user.acceptsCustomPrivacy ? 'icon-check_circle_filled' : 'icon-close_circle_filled'"
                />
                <PrivacyConsentCustomInfo/>
            </div>
            <PrivacyConsentWithdrawalInfo/>
            <button
                @click="isEditMode=!isEditMode"
                class="btn btn--md btn--w-144 btn__primary"
            >
                {{ $t('edit') | capitalize }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import GdprUpdateContainer from '../gdpr/GdprUpdateContainer';

    export default {
        name: 'GdprShowUpdateContainer',
        data() {
            return {
                isEditMode: false,
            };
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        methods: {
            onCancel() {
                this.isEditMode = false;
            },
        },
        components: {
            GdprUpdateContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/userProfile/settings/GdprShowUpdateContainer.vue